'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var qwest = _interopRequireWildcard(require("qwest"));
var _is_js = _interopRequireDefault(require("is_js"));
var _TextInput = _interopRequireDefault(require("Components/Forms/Elements/TextInput"));
var _Select = _interopRequireDefault(require("Components/Forms/Elements/Select"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));
var _getErrorsFromResponse = _interopRequireDefault(require("Components/Forms/Functions/getErrorsFromResponse"));
var _getFormStatus = _interopRequireDefault(require("Components/Forms/Functions/getFormStatus"));
var _handleChange = _interopRequireDefault(require("Components/Forms/Functions/handleChange"));
var _getStateFromObject = _interopRequireDefault(require("Components/Forms/Functions/getStateFromObject"));
var _getFormData = _interopRequireDefault(require("Components/Forms/Functions/getFormData"));
var _Loader = _interopRequireDefault(require("Pure/Loader"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
let app = window.app;
const roles = [{
  value: 'admin',
  label: 'Administrateur'
}, {
  value: 'agent',
  label: 'Responsable de secteur'
}, {
  value: 'accompanist',
  label: 'Accompagnateur'
}, {
  value: 'companies-manager',
  label: 'Gestionnaire compte entreprise'
}];
class UserForm extends _react.Component {
  state = {
    status_messages: {}
  };
  handleChange = _handleChange.default.bind(this);
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    if (props.type === 'update') {
      component.fetchUser();
    }
    component.fetchSectors();
  }
  fetchUser = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/user/get-all', {
      id: props.id || document.location.pathname.split('/configuration/liste-des-utilisateurs/')[1],
      with_count: false
    }).then(function (xhr, response) {
      const roles = response.users[0].roles[0];
      delete response.users[0].roles;
      const update = (0, _getStateFromObject.default)({
        data: response.users[0],
        model: 'user'
      });
      component.setState({
        ...update,
        'user[roles]': roles,
        loading: false
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
    component.setState({});
  };
  fetchSectors = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/sector/get-all').then(function (xhr, response) {
      component.setState({
        loading: false,
        sectors: response.sectors
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  validate = e => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.loading === true) return;
    component.setState({
      loading: true
    });
    const user = (0, _getFormData.default)({
      state: state,
      pattern: 'user['
    });
    const url = props.type === 'update' ? '/user/update' : '/user/create';
    qwest.post(url, user).then(function (xhr, response) {
      if (props.type === 'update') {
        component.fetchUser();
      } else {
        component.clearForm();
        window.setTimeout(function () {
          app.navigateTo('/configuration/liste-des-utilisateurs');
        }, 2000);
      }
      component.setState({
        loading: false,
        info: response.info,
        error: undefined,
        warning: undefined,
        status_messages: {}
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  clearForm = () => {
    const component = this,
      props = this.props,
      state = this.state;
    const update = Object.keys(state).filter(key => key.startsWith('user[')).reduce(function (update, key) {
      console.log(state[key], _is_js.default.string(state[key]));
      if (_is_js.default.string(state[key])) {
        update[key] = '';
      } else if (_is_js.default.array(state[key])) {
        update[key] = [];
      } else if (_is_js.default.json(state[key])) {
        update[key] = {};
      }
      return update;
    }, {});
    component.setState(update);
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const status = (0, _getFormStatus.default)(state);
    const loader = state.loading === true ? /*#__PURE__*/_react.default.createElement(_Loader.default, {
      className: "c-loader",
      bemit: ['white', 'bg-primary']
    }) : undefined;
    const sector_options = (state.sectors || []).map(function (sector) {
      let option = {
        label: sector.name,
        value: sector.id
      };
      return option;
    });
    let output = /*#__PURE__*/_react.default.createElement("form", {
      method: "POST",
      action: "/user/create"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "u-full-width u-padding-bottom-20 u-text-center"
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      color: "primary",
      variant: "contained",
      size: "large",
      onClick: component.validate
    }, props.type === 'update' ? 'Mettre à jour' : 'Créer cet utilisateur', loader)), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 3,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['user[lastname]'],
      name: "user[lastname]",
      type: "text",
      label: "Nom",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['user[firstname]'],
      name: "user[firstname]",
      type: "text",
      label: "Pr\xE9nom",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['user[home_phone_number]'],
      name: "user[home_phone_number]",
      type: "text",
      label: "T\xE9l\xE9phone fixe",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['user[phone_number]'],
      name: "user[phone_number]",
      type: "text",
      label: "T\xE9l\xE9phone portable",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['user[login]'],
      name: "user[login]",
      type: "text",
      label: "E-mail (login)",
      autocomplete: "new-email",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['user[password]'],
      name: "user[password]",
      type: "password",
      label: "Mot de passe",
      autocomplete: "new-password",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Select.default, {
      onChange: component.handleChange,
      value: state['user[roles]'],
      name: "user[roles]",
      label: "R\xF4le",
      status: state.status_messages,
      options: roles,
      defaultValue: roles[0].value
    })), state['user[roles]'] === 'agent' ? /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Select.default, {
      onChange: component.handleChange,
      value: state['user[sector]'],
      name: "user[sector]",
      label: "Secteur",
      status: state.status_messages,
      options: sector_options,
      defaultValue: sector_options[0]?.value
    })) : undefined), status, /*#__PURE__*/_react.default.createElement("div", {
      className: "u-full-width u-margin-top-25 u-padding-bottom-20 u-text-center"
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      color: "primary",
      variant: "contained",
      size: "large",
      onClick: component.validate
    }, props.type === 'update' ? 'Mettre à jour' : 'Créer cet utilisateur', loader)));
    return output;
  }
}
exports.default = UserForm;
